module.exports = __webpack_public_path__ + "static/media/ss-horizontal.e66085a2.svg";